/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./def.defs.js";
export { main as default } from "./def.defs.js";
